import { InjectionToken } from '@angular/core';

export interface VestaWindow extends Window {
  callVesta3DManager?: (url: string) => Promise<void>;
}

export const VESTA_WINDOW = new InjectionToken<VestaWindow>(
  'VESTA_WINDOW',
  {
    providedIn: 'root',
    factory: () => window as VestaWindow
  }
);
